import { Link, useLocation } from "react-router-dom";
import { CircleHelp } from "lucide-react";
import { manualIdFor } from "@/components/manual/icons";

export const HelpButton = () => {
  const { pathname } = useLocation();
  const id = manualIdFor(pathname);
  if (pathname.startsWith("/manuale")) return null;
  return (
    <Link to={`/manuale/${id}`} data-testid="help-button" title="Guida di questa sezione"
      className="inline-flex h-8 w-8 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-500 transition-colors hover:border-blue-200 hover:bg-blue-50 hover:text-blue-700">
      <CircleHelp className="h-4 w-4" strokeWidth={1.8} />
    </Link>
  );
};
